export default {
  common: {
    login: "Anmelden",
    userName: "Benutzername",
    password: "Passwort",
    rememberPassword: "Angemeldet bleiben",
    modifyPassword: "Passwort ändern",
    accountRegister: "Kontoregistrierung",
    pleaseInput: "Bitte eingeben",
    loginErrorCheckNamePassword: "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Benutzername und Passwort",
    guest: "Gast",
    superAdmin: "Superadministrator",
    logOut: "Abmelden",
    inputUserName: "Benutzernamen eingeben",
    inputPassword: "Passwort eingeben",
    modifySuccessfully: "Passwort erfolgreich geändert!",

    using: "Verwendung",
    toLogin: "Zur Anmeldung",

    noOktaLoginUrl: "Keine OKTA-Anmelde-URL",
    uncheckSwitch: "Deaktivieren Sie dieses Kontrollkästchen, um in den regulären Anmeldemodus zu wechseln",

    noADLoginUrl: "Keine Azure-AD-Anmelde-URL"
  },
  register: {
    email: "E-Mail-Adresse",
    confirmPassword: "Passwort bestätigen",
    register: "Registrieren",
    emailRequire: "E-Mail-Adresse ist erforderlich",
    passwordRequire: "Passwort ist erforderlich",
    confirmPasswordRequire: "Passwortbestätigung ist erforderlich",
    passwordInconsistency: "Die Passwörter stimmen nicht überein",
    registeredSuccessfully: "Erfolgreich registriert!",
    jumpToLoginPage: "Das System leitet Sie automatisch zur Anmeldeseite weiter.",
    contactAdminActivate: "Bitte wenden Sie sich vor der Anmeldung an den Administrator, um das Konto aktivieren zu lassen.",
    USER_EXISTS: "Dieser Benutzer ist bereits vorhanden",

    emailExists: "E-Mail-Adresse ist bereits vorhanden",
    emailInconsistency: "Die E-Mail-Adressen stimmen nicht überein",
    confirmEmailAddress: "E-Mail-Adresse bestätigen",
    emailAgain: "E-Mail-Adresse erneut eingeben",
    approvedCarrierOnly: "Ausschließlich für autorisierte Carrier-Mitarbeiter."
  },
  my: {
    about: "Über",
    language: "Sprache",
    nomenclatureList: "Begriffsverzeichnis",

    appName: "Anwendungsname",
    version: "Version",
    iecmFF: "iECM-Funktionsrahmen",
    paragraph1:
      "1. Die Methoden zur Schätzung der Ausgangsbasis entsprechen vollständig dem International Performance Measurement and Verification Protocol (IPMVP). Jede Methode ist an den IPMVP-Richtlinien ausgerichtet, um eine belastbare und transparente Bewertung der energetischen Leistung sicherzustellen.",
    paragraph2: "2. Die aktuelle Bibliothek verwendet Leistungskennlinien auf Basis von AHRI-Bedingungen.",
    paragraph3: "3. Die Eingabe AHRI-zertifizierter e-CAT-Leistungsdaten für einen Flüssigkeitskühler nach der Modernisierung ist zulässig.",

    learningCenter: "Lernzentrum",
    learningCenterDescription: "Greifen Sie auf Schulungsvideos, Benutzerhandbücher und Anleitungen zu Arbeitsabläufen zu, um iECM effektiver zu nutzen."
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/de.js